export const UPDATE_CHATS_STATE = 'UPDATE_CHATS_STATE';
export const UPDATE_CHAT_STATE_VALUE = 'UPDATE_CHAT_STATE_VALUE';
export const CHATS_MAKE_SOCKET_CONNECTION = 'CHATS_MAKE_SOCKET_CONNECTION';
export const CHATS_SOCKET_DISCONNECT = 'CHATS_SOCKET_DISCONNECT';
export const CALL_CHATS_SOCKET_METHOD = 'CALL_CHATS_SOCKET_METHOD'
export const CHATS_ADDITION = 'CHATS_ADDITION';
export const CHATS_UPDATION = 'CHATS_UPDATION';
export const CHATS_DELETION = 'CHATS_DELETION';
export const JOIN_CHATS_PAGE = 'JOIN_CHATS_PAGE';
export const SWITCH_ALREADY_JOINED_CHAT = 'SWITCH_ALREADY_JOINED_CHAT';
export const EMIT_MESSAGE_SEEN = 'EMIT_MESSAGE_SEEN';
export const CLOSE_CHAT_INTERFACE = 'CLOSE_CHAT_INTERFACE';
export const CHAT_ROOM_JOINED = 'CHAT_ROOM_JOINED';
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';
export const EMIT_CHATS_CUSTOM_EVENT = 'EMIT_CHATS_CUSTOM_EVENT';
export const UPDATE_CHAT_PROFILE = 'UPDATE_CHAT_PROFILE';
export const UPDATE_CHAT_MESSAGE = 'UPDATE_CHAT_MESSAGE';
export const UPDATE_TYPING_INFO = 'UPDATE_TYPING_INFO';
export const UPDATE_UNREAD_LIVE_MESSAGE_COUNT = 'UPDATE_UNREAD_LIVE_MESSAGE_COUNT';
export const JOIN_CHAT_ITEM_BY_PSID = 'JOIN_CHAT_ITEM_BY_PSID';
export const CHAT_ITEM_CLICKED = 'CHAT_ITEM_CLICKED'
export const JOINED_ROOM_USER_PROFILE_RECEIVED = 'JOINED_ROOM_USER_PROFILE_RECEIVED'
export const JOIN_CHAT_ROOM = 'JOIN_CHAT_ROOM'
export const CHAT_LIST_RECEIVED_ON_JOIN = 'CHAT_LIST_RECEIVED_ON_JOIN';
export const UNTAGGED_CHATLOG_RECEIVED = 'UNTAGGED_CHATLOG_RECEIVED'






export const CHATS_MESSAGE_SEEN = 'CHATS_MESSAGE_SEEN';



export const GROUP_TAGS_LOADED = 'GROUP_TAGS_LOADED';
export const ADD_SELECTED_TAG = 'ADD_SELECTED_TAG';
export const REMOVE_SELECTED_TAG = 'REMOVE_SELECTED_TAG';



// WEBPACK FOOTER //
// ./src/data/redux/chats_details/actiontypes.js